import React from "react";

const Pagination = ({ selectedPage, totalPages, handlePageChange }) => {
  const currentPage = selectedPage + 1; // Convert to 1-indexed for display
  const totalPagesCount = totalPages;

  const generatePageNumbers = () => {
    const pages = [];

    // Always show first page
    if (totalPagesCount > 0) {
      pages.push(
        <li key={1} className={currentPage === 1 ? "active" : ""}>
          <button
            className={`uk-button ${currentPage === 1 ? "uk-button-secondary" : "uk-button-default"
              }`}
            onClick={() => {
              handlePageChange(0);
              window.scroll({ top: 0, left: 0, behavior: "smooth" });
            }}
          >
            1
          </button>
        </li>,
      );
    }

    // Show ellipsis if needed
    if (currentPage > 3) {
      pages.push(
        <li key="ellipsis-start" className="disabled">
          <span>...</span>
        </li>,
      );
    }

    // Show pages around current page
    for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPagesCount - 1, currentPage + 1);
      i++
    ) {
      pages.push(
        <li key={i} className={currentPage === i ? "active" : ""}>
          <button
            className={`uk-button ${currentPage === i ? "uk-button-secondary" : "uk-button-default"
              }`}
            onClick={() => {
              handlePageChange(i - 1);
              window.scroll({ top: 0, left: 0, behavior: "smooth" });
            }}
          >
            {i}
          </button>
        </li>,
      );
    }

    // Show ellipsis if needed
    if (currentPage < totalPagesCount - 2) {
      pages.push(
        <li key="ellipsis-end" className="disabled">
          <span>...</span>
        </li>,
      );
    }

    // Always show last page if there's more than 1 page
    if (totalPagesCount > 1) {
      pages.push(
        <li
          key={totalPagesCount}
          className={currentPage === totalPagesCount ? "active" : ""}
        >
          <button
            className={`uk-button ${currentPage === totalPagesCount
                ? "uk-button-secondary"
                : "uk-button-default"
              }`}
            onClick={() => {
              handlePageChange(totalPagesCount - 1);
              window.scroll({ top: 0, left: 0, behavior: "smooth" });
            }}
          >
            {totalPagesCount}
          </button>
        </li>,
      );
    }

    return pages;
  };

  return (
    <div className="uk-width-1-1 uk-padding-remove uk-text-center uk-margin-medium-top">
      <nav className="pagination-wrapper">
        <ul
          className="pagination uk-flex uk-flex-center uk-flex-wrap"
          style={{ gap: "0.5rem" }}
        >
          {/* Previous Button */}
          <li className={selectedPage === 0 ? "disabled" : ""}>
            <button
              className="uk-button uk-button-default"
              disabled={selectedPage === 0}
              onClick={() => {
                handlePageChange(selectedPage - 1);
                window.scroll({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              Previous
            </button>
          </li>

          {/* Page Numbers */}
          {generatePageNumbers()}

          {/* Next Button */}
          <li className={selectedPage >= totalPages - 1 ? "disabled" : ""}>
            <button
              className="uk-button uk-button-default"
              disabled={selectedPage >= totalPages - 1}
              onClick={() => {
                handlePageChange(selectedPage + 1);
                window.scroll({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              Next
            </button>
          </li>
        </ul>
        {/* <p className="uk-text-center uk-text-muted uk-margin-small-top">
          Page {selectedPage + 1} of {totalPages}
        </p> */}
      </nav>
    </div>
  );
};

export default Pagination;
